import React, { useEffect, useState, useRef, Suspense } from 'react'
import axios from 'axios'
import './index.scss'
import { searchByDsl, discoverV2 } from '../../services/catalogSearchService'
// import ReactJson from 'react-json-view'
import { Col, Row, Button, Divider } from 'antd'
import ProductsList from '../../containers/search/ProductsList'
import { SearchContext, useSearchContext } from '../discovery/context'

// import MonacoEditor from 'react-monaco-editor'
const MonacoEditor = React.lazy(() => import('react-monaco-editor'))
const ReactJson = React.lazy(() => import('react-json-view'))

function useSearchDsl() {
  const [dsl, setDsl] = useState<string>('')
  const [res, setRes] = useState<any>({})
  useEffect(() => {
    if (!dsl) return
    searchByDsl(dsl)
      .then(res => {
        console.log(res.data)
        setRes(res.data)
      })
      .catch(e => {
        console.error(e)
      })
  }, [dsl])

  return { dsl, setDsl, response: res }
}

const editorConfig: { wordWrap: 'on' } & any = {
  minimap: {
    enabled: false,
  },
  lineDecorationsWidth: 5,
  scrollbar: {
    verticalScrollbarSize: 5,
    horizontalScrollbarSize: 5,
  },
  wordWrap: 'on',
  automaticLayout: true,
}

function SearchDebuggerHeader() {
  const { queryParams, setQueryParams, setSearchResult, setSearchLoading } = useSearchContext()
  const [dslContent, setDslContent] = useState(JSON.stringify(
    {
      "from": 0,
      "size": 20,
      "query": {
        "bool": {
          "must": [
            {
              "match": {
                "inventoryStatus": "AVAILABLE"
              }
            },
            {
              "match": {
                "allowPurchase": "true"
              }
            },
            {
              "match": {
                  "type": "REGULAR"
              }
            }
          ]
        }
      }
    }
  , undefined, 4))
  const { setDsl, response } = useSearchDsl()
  const abortHandler = useRef<any>(null)
  useEffect(() => {
    if (!response) return
    const ids = response.hits?.hits?.map(p => p._id) || []
    if (ids?.length) {
      setQueryParams({ pid: ids, f: 0, t: ids.length })
    }
  }, [response, setQueryParams])
  const onCodeChange = (code: any) => {
    try {
      setDslContent(code)
    } catch (e) {
      console.warn(e)
    }
  }
  useEffect(() => {
    const searchProduct = (queryParams) => {
      if (abortHandler.current) {
          // abort the previous request first
          abortHandler?.current?.cancel()
      }
      abortHandler.current = axios.CancelToken.source()
      setSearchLoading(true)
      discoverV2(queryParams, abortHandler.current)
          .then(res => {
              setSearchLoading(false)
              if (res.data) {
                  console.log(res.data)
                  setSearchResult(res.data)
              }
          })
          .catch(error => {
              console.error(error)
              // message.error('Failed to search products!')
              setSearchLoading(false)
          })
    }
    if (!queryParams || !queryParams.pid?.length) return
    searchProduct(queryParams)
  }, [queryParams])

  return (
    <Row gutter={12} className="sdg-header">
      <Col span={10} className="sdg-dsl-input">
        <Suspense fallback={<div></div>}>
          <MonacoEditor
            language="json"
            theme="vs-light"
            height={500}
            value={dslContent}
            onChange={onCodeChange}
            options={editorConfig}
          />
        </Suspense>
      </Col>
      <Col span={2}>
        <div className="sdg-btns">
          <Button onClick={() => setDsl(dslContent)}>搜索</Button>
        </div>
      </Col>
      <Col span={12} className="sdg-res-viewer">
        <Suspense fallback={<div></div>}>
          <ReactJson collapsed={1} style={{ padding: '20px' }} src={response} quotesOnKeys={false} displayDataTypes={false} enableClipboard={false} name={null} />
        </Suspense>
      </Col>
    </Row>
  )
}

const SearchDslPage = () => {
  const [searchResult, setSearchResult] = useState<any>(null)
  const [searchLoading, setSearchLoading] = useState(false)
  const [expandFlag, setExpandFlag] = useState(false)
  const [queryParams, setQueryParams] = useState<any>({
    pid: [], // pids
  })
  return (
    <SearchContext.Provider
      value={{
        queryParams,
        setQueryParams,
        expandFlag,
        setExpandFlag,
        searchResult,
        setSearchResult,
        setSearchLoading,
        searchLoading,
      }}
    >
      <div className="sdg-container">
        <SearchDebuggerHeader />
        <Divider />
        {queryParams?.pid?.length > 0 ? <ProductsList /> : null}
      </div>
    </SearchContext.Provider>
  )
}

export default SearchDslPage
